import styled from 'styled-components';

export const Row = styled.div`
    display: flex;
    padding-left: var(--sidebar-width);
    margin-right: -1rem;
    margin-left: -1rem;
    flex-wrap: wrap;
`;
